import React, { useEffect } from 'react';
import { Select } from 'antd';


function Login() {
  return (
    <div className="flex justify-end items-center mr-8 md:mr-2">
      <Select
        size="small"
        value="English"
        className="hidden lg:block lg:mr-10"
      >
        <Select.Option value="English">English</Select.Option>
      </Select>

      <button className="px-3 py-2 rounded inline-flex items-center bg-transparent text-purple-700 font-semibold border border-purple-700 md:mr-5">
          <svg className="fill-current w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M0 2C0 .9.9 0 2 0h16a2 2 0 012 2v16a2 2 0 01-2 2H2a2 2 0 01-2-2V2zm7 4v2a3 3 0 106 0V6a3 3 0 10-6 0zm11 9.1a16 16 0 00-8-2.1c-3 0-5.7.8-8 2.1V18h16v-2.9z"/></svg>
          <span className="text-sm uppercase tracking-wide">Login/Register</span>
      </button>
    </div>
  );
}

export default Login;


